import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('smoke_check', '/smoke_checks')
const reducer = generator.generate()

export default reducer
